import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import styles from "./ValidatedStateDisplay.module.scss";
import Button from "../../atom/Button/Button";
export interface ValidatedStateDisplayProps {
  validationMessage: string;
  withGoHomeButton?: boolean;
  labelBtn?: string;
  onClickBtn?: () => void;
  marginLeft?: string;
  width?: string;
}

/**
 * ValidatedStateDisplay
 * @returns
 */
export default function ValidatedStateDisplay({
  validationMessage,
  labelBtn,
  onClickBtn,
  marginLeft,
    width
}: ValidatedStateDisplayProps) {
  return (
    <div style={{marginLeft:marginLeft, width }} className={styles["global-container"]}>
      <div className={styles["global-container__icon"]}>
        <DotLottieReact
          src="https://lottie.host/a130b316-2131-483f-977c-a0443738e841/LQqbEh7OPc.lottie"
          loop={false}
          autoplay
        />
      </div>
      <p className={styles["global-container__message"]}>{validationMessage}</p>
      <div className={styles["global-container__btn-container"]}>
        {onClickBtn && <Button label={labelBtn} onClick={onClickBtn} />}
      </div>
    </div>
  );
}
